/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class AccountTypeGrid extends SiteEntityGrid<AccountTypeRow, any> {
        protected getColumnsKey() { return 'Data.AccountType'; }
        protected getDialogType() { return AccountTypeDialog; }
        protected getIdProperty() { return AccountTypeRow.idProperty; }
        protected getLocalTextPrefix() { return AccountTypeRow.localTextPrefix; }
        protected getService() { return AccountTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}